import PropertyShareButton from "./PropertyShareButton";

export default PropertyShareButton;
